module.exports = __webpack_public_path__ + "static/media/motor6.0c094985.jpg";